export class Rational {
  readonly n: bigint;
  readonly d: bigint;
  constructor(n: bigint | number = 0n, d: bigint | number = 1n) {
    let nn = BigInt(n), dd = BigInt(d);
    if (dd === 0n) throw new Error('zero denominator');
    if (dd < 0n) { nn = -nn; dd = -dd; }
    const g = gcd(nn < 0n ? -nn : nn, dd);
    this.n = nn / g; this.d = dd / g;
  }
  static parse(value: string | null | undefined): Rational {
    if (value == null || value.trim() === '') return Rational.zero;
    const s = value.trim();
    if (/^[+-]?\d+$/.test(s)) return new Rational(BigInt(s));
    const m = /^([+-]?)(\d*)\.(\d+)$/.exec(s);
    if (!m) throw new Error(`invalid rational: ${value}`);
    const frac = m[3]!, denom = 10n ** BigInt(frac.length);
    const sign = m[1] === '-' ? -1n : 1n;
    return new Rational(sign * (BigInt(m[2] || '0') * denom + BigInt(frac)), denom);
  }
  static readonly zero = new Rational(0n);
  static readonly one = new Rational(1n);
  add(o: Rational): Rational { return new Rational(this.n * o.d + o.n * this.d, this.d * o.d); }
  sub(o: Rational): Rational { return new Rational(this.n * o.d - o.n * this.d, this.d * o.d); }
  mul(o: Rational): Rational { return new Rational(this.n * o.n, this.d * o.d); }
  div(o: Rational): Rational { return new Rational(this.n * o.d, this.d * o.n); }
  cmp(o: Rational): number { const a=this.n*o.d,b=o.n*this.d; return a<b?-1:a>b?1:0; }
  eq(o: Rational): boolean { return this.n===o.n && this.d===o.d; }
  max(o: Rational): Rational { return this.cmp(o)>=0?this:o; }
  toString(): string { return this.d===1n?`${this.n}`:`${this.n}/${this.d}`; }
}
function gcd(a: bigint,b: bigint): bigint { while(b!==0n)[a,b]=[b,a%b]; return a||1n; }
